export const Assets = {
    COMPANY_LOGO_LOCAL: '/images/logo.png',
    NO_IMAGE_ITEM: '/images/products/no-image-item.jpeg',
}